import type { ICognitoStorage } from 'amazon-cognito-identity-js';

/**
 * In-memory storage for the Cognito SDK. Tokens never touch `localStorage`; the app keeps them in
 * memory and uses the refresh token to recover after a reload (web) or from secure storage
 * (mobile), both outside this package.
 */
export class MemoryStorage implements ICognitoStorage {
  private readonly data = new Map<string, string>();

  /**
   * Stores one value.
   */
  setItem(key: string, value: string): void {
    this.data.set(key, value);
  }

  /**
   * Reads one value, or `null` when absent, as the SDK expects.
   */
  getItem(key: string): string | null {
    return this.data.get(key) ?? null;
  }

  /**
   * Removes one value.
   */
  removeItem(key: string): void {
    this.data.delete(key);
  }

  /**
   * Drops everything, used on sign-out.
   */
  clear(): void {
    this.data.clear();
  }
}
